import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { AuthContext } from "../../contexts/authContext";
import Grid from "@material-ui/core/Grid/Grid";
import LoginBox from '../../components/loginBox';
import Modal from '../../common/modal';
import PltwNavBar from '../../common/pltwNavBarLogin';

import { pltwMassLogo, zeroWasteLogo } from '../../common/images';

import './loginPage-styles.scss';

const LoginPage = ({ history }) => {


  // const correctCode = 'MA-STEM19';
  // const testAccessCode = 'ABC123';
  const [accessCode, setAccessCode] = useState('');
  const [modalOpen, setModalOpen] = useState(false);


  const API_ENDPOINT = 'https://59xwf83xci.execute-api.us-west-2.amazonaws.com/pltw';
  const API_KEY = 'qUVcsBH47t7zpZtoii3x75y0Jf6sEnzi3mK8PWv1';

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
      <AuthContext.Consumer>{ (context)=>{
        const { processLogin } = context
        const handleSubmit = (e) =>{
          e.preventDefault()
          // Fetch Lambda endpoint with accessCode
          fetch(API_ENDPOINT, {
            method: "POST",
            body: JSON.stringify({ accessCode }),
            headers: {
              "x-api-key": API_KEY
            },
            credentials: "same-origin"
          }).then(function(response) {
            if (response.status===200){
              processLogin()
              history.push('/welcome');
            } else {
              setModalOpen(true);
            }
          }).catch( (error)=>{
            console.log(error)
          })
        }
        return(
            <div className='login-container'>
              <Modal code={accessCode} handleClose={closeModal} open={modalOpen} />
              <Grid container justify="center" alignItems="center" spacing={2}>
                <Grid item xs={12} style={{ paddingBottom: '0px' }}>
                  <PltwNavBar />
                </Grid>
                <Grid item xs={12} style={{ paddingTop: '0px' }}>
                  <div className='zeroWaste-container'>
                    <img src={zeroWasteLogo} className='zeroWaste-logo' alt='zero waste' />
                  </div>
                </Grid>
                <LoginBox accessCode={accessCode} handleSubmit={handleSubmit} setAccessCode={setAccessCode} />
                <Grid container alignItems="flex-start" className='brought-by'>
                  <Grid item md={4} sm={7} xs={12}>
                    <Grid item xs={12}>
                      <h2>STEM WEEK CHALLENGE:</h2>
                    </Grid>
                    <Grid item xs={12}>
                      <img src={pltwMassLogo} alt='PLTW and Mass Stem Hub' className='brought-by-logo' />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
        )
      }}
      </AuthContext.Consumer>
  );
};

export default withRouter(LoginPage);
